/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tokens_IntroInputs */

const en_tokens_intro = /** @type {(inputs: Tokens_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For the iOS Shortcut “Save to Dishly”. A token can only send recipes to import, nothing else.`)
};

const de_tokens_intro = /** @type {(inputs: Tokens_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für den iOS-Kurzbefehl „In Dishly sichern“. Ein Token kann nur Rezepte zum Import schicken, sonst nichts.`)
};

/**
* | output |
* | --- |
* | "For the iOS Shortcut “Save to Dishly”. A token can only send recipes to import, nothing else." |
*
* @param {Tokens_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_intro = /** @type {((inputs?: Tokens_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_intro(inputs)
	return en_tokens_intro(inputs)
});